import React from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';
export var MuiCheckBox = function (props) {
    var checkBoxValue = props.checkBoxValue, handleChange = props.handleChange, _a = props.label, label = _a === void 0 ? '' : _a, _b = props.labelPlacement, labelPlacement = _b === void 0 ? 'end' : _b, sx = props.sx, disabled = props.disabled, id = props.id;
    return /*#__PURE__*/ React.createElement(FormControlLabel, {
        control: /*#__PURE__*/ React.createElement(Checkbox, {
            disabled: disabled,
            checked: checkBoxValue,
            onChange: handleChange,
            id: id
        }),
        label: label,
        labelPlacement: labelPlacement,
        sx: sx
    });
};
